import { useDisclosure } from "@/hooks";
import { CLIENT_API } from "@/services/axios-client";
import { useNFCStore } from "@/states/zustand/nfc";
import { useNotificationStore } from "@/states/zustand/notification";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { UserDataModal } from "./component/UserDataModal";

export function NFCReader({
	isInAttendanceComp = false,
}: {
	isInAttendanceComp?: boolean;
}) {
	const { readData: userId, setReadData } = useNFCStore();

	const [meditatorData, setMeditatorData] =
		useState<MeditatorWithMeditationRetreat | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const [opened, { open, close }] = useDisclosure(false);

	useEffect(() => {
		if (userId) {
			if (!userId) {
				useNotificationStore.getState().setNotification({
					type: "warning",
					message: "No data found in this NFC card!",
				});
				return;
			}

			if (userId && !isNumber(userId)) {
				useNotificationStore.getState().setNotification({
					type: "warning",
					message: "Invalid data received from NFC card!",
				});
				return;
			}

			(async () => {
				setLoading(true);
				await CLIENT_API.getMeditatorById(userId)
					.then((data) => {
						setMeditatorData(data);
						open();
					})
					.catch((err) => {
						useNFCStore.getState().setReadData(null);
						useNotificationStore.getState().setNotification({
							type: "error",
							message:
								err?.message ||
								err?.data?.error?.message ||
								"Failed to get user data!",
						});
					})
					.finally(() => {
						useNFCStore.getState().setReadData(null);
						setLoading(false);
					});
			})();
		}
	}, [userId]);

	return (
		<Spin spinning={loading}>
			<div className="flex flex-col items-center gap-6 p-10">
				<h3 className=" text-2xl font-semibold font-poppins text-center ">
					Put the NFC Tag near to the NFC Driver
				</h3>
				<img
					src="/assets/img_nfc.png"
					className=" max-w-xl w-full object-cover"
				/>
				{meditatorData && (
					<UserDataModal
						meditatorData={meditatorData}
						opened={opened}
						closeModal={() => {
							close();
							setReadData(null);
							setMeditatorData(null);
						}}
						isInAttendanceComp={isInAttendanceComp}
					/>
				)}
			</div>
		</Spin>
	);
}

const isNumber = (input: string) => {
	const numberRegex = /^\d+$/;

	return numberRegex.test(input);
};
